<script setup>
import { storeToRefs } from 'pinia'

import { useAlertStore } from '@/stores'

const alertStore = useAlertStore()
const { alert } = storeToRefs(alertStore)
//watch alert and change visibility of myModal?
</script>

<template>
  <!--div v-if="alert" class="container">-->

  <!-- The Modal -->
  <div v-if="alert && alert.value!==null" id="myModal" class="modal">
    <!-- Modal content -->
    <div class="modal-content">
      <!--span class="close">&times;</span>-->
      <button v-if="alert.type!='alert-loading'" @click="alertStore.clear()" class="btn btn-link close">&times;</button>
      <p>{{ alert.message }}</p>
      <!--p> fake alert message ...</p-->
    </div>
  </div>
  <!--
        <div class="m-3">
            <div class="alert alert-dismissable" :class="alert.type">
                <button @click="alertStore.clear()" class="btn btn-link close">&times;</button>
                {{ alert.message }}
            </div>
        </div>
    -->

  <!-- Trigger/Open The Modal -->
  <!--button id="myBtn">Open Modal</button-->
</template>

<style lang="css" scoped>
/* The Modal (background) */
.modal {
  /*display: none;*/
  display: block;
  /* Hidden by default */
  position: fixed;
  /* Stay in place */
  z-index: 1000;
  /* Sit on top */
  left: 0;
  top: 0;
  width: 100%;
  /* Full width */
  height: 100%;
  /* Full height */
  overflow: auto;
  /* Enable scroll if needed */
  background-color: rgb(0, 0, 0);
  /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4);
  /* Black w/ opacity */
}

/* Modal Content/Box */
.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  /* 15% from the top and centered */
  padding: 20px;
  border: 1px solid #888;
  width: 60%;
  /* Could be more or less, depending on screen size */
}

/* The Close Button */
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
</style>
